import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const FourierTransformProperties = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Properties of Fourier Transform"
    videos={[
      "https://www.youtube.com/embed/4rGY_lYS1Sk",
      "https://www.youtube.com/embed/VorPCuBr3Pw",
      "https://www.youtube.com/embed/c4wqzTbS9I0",
      "https://www.youtube.com/embed/djMcvOnUZIs",
    ]}
    takeaways={[]}
    questions={[]}
    exampleVideos={[]}
  />
);
}

export default FourierTransformProperties;
